var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"price-input-button",attrs:{"type":"button"}},_vm.$listeners),[_c('HdIcon',{staticClass:"price-input-button__sign",attrs:{"src":_vm.signIcon,"width":"22","height":"22"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }